export default "__VITE_ASSET__VvCd8eaN__"